import { render, staticRenderFns } from "./HostingWhmAccountAdd.vue?vue&type=template&id=6b4826a7&"
import script from "./HostingWhmAccountAdd.vue?vue&type=script&lang=js&"
export * from "./HostingWhmAccountAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4826a7')) {
      api.createRecord('6b4826a7', component.options)
    } else {
      api.reload('6b4826a7', component.options)
    }
    module.hot.accept("./HostingWhmAccountAdd.vue?vue&type=template&id=6b4826a7&", function () {
      api.rerender('6b4826a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/reseller/HostingWhmAccountAdd.vue"
export default component.exports